const API = window.location.origin;

// Fired once at module load time — before React renders anything.
// Stores the promise so the featured poem hook can await it instead
// of making a duplicate request.
let featuredPromise = null;

export function preloadFeatured() {
  if (featuredPromise) return featuredPromise;
  featuredPromise = fetch(`${API}/api/poems/browse?mode=featured`, { priority: 'high' })
    .then(r => r.ok ? r.json() : null)
    .catch(() => null);
  return featuredPromise;
}

export function getFeaturedPreload() {
  return featuredPromise;
}
